import { useMemo } from 'react';
import { useStationsQuery } from './useStationsQuery';
import { Station } from '@app/core/types/stations';

/**
 * Hook to get all stations as an array from the React Query cache (primed from app-init).
 * Returns empty array if data is not loaded yet.
 */
export function useStations(filter?: (s: Station) => boolean): readonly Station[] {
  const query = useStationsQuery();
  const stationsData = query.data ?? [];

  return useMemo(
    () => (filter ? stationsData.filter(filter) : stationsData),
    [stationsData, filter],
  );
}

/**
 * Hook to get a finder function that can find a station by id or slug.
 */
export function useStationsFinder() {
  const stations = useStations();

  return useMemo(
    () => (idOrSlug: string) => {
      return stations.find((s) => s.slug === idOrSlug || s.id === idOrSlug) || null;
    },
    [stations],
  );
}
